import { useIntl } from 'react-intl';
import _ from 'lodash';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { useFormik } from 'formik'
import { deleteOne, patchOne, createOne } from '../../../../services/common_requests';
import { toast } from 'react-toastify'
import { useEffect, useRef, useState } from 'react';
import { ID, KTCardBody, QUERIES } from '../../../../../_dashboard/helpers';
import { useQueryClient } from 'react-query';
import { images } from '../../../hotel-management/hotel-details/core/_models';
//import ImageEditModal from '../../../hotel-management/hotel-details/image-edit-modal/ImageEditModal';
import { AddAttributeModal } from './AddAttributeModal';
import { DeleteResponse } from '../../../hotel-management/hotel-details/HotelDetails';
import ImageGallery from './ImageGallery';
import ImageAddModal from './ImageAddModal';
import ImageEditModal from './ImageEditModal';
import { ToggleButton } from './ToggleButton';
import { useConfirm } from '../../../../components/ConfirmProvider';

//import { useQueryResponse } from '../core/QueryResponseProvider';
import { useQueryResponse } from '../../pages-list/core/QueryResponseProvider'

export interface Translation {
    _id: string;
    sliderItem_id: string;
    language: string;
    text: string;
    description: string;
    buttonText: string;
    __v: number;
}

export interface Attribute {
    _id: string;
    type: string;
    translations: Translation[];
    image?: {
        _id:string,
        url: string;
        seoUrl: string;
    };
}

interface Block {
    _id: string;
    position?: string;
    translations: Translation[];
    attributes: Attribute[];
    pageId:string
}
interface Image {
    _id: ID;
    url: string;
    seoUrl?: string;
}

interface SliderItem {
    _id: string;
    slider_id: string;
    image: Image;
    link: string;
    translations: Translation[];
    __v: number;
  }
const SliderComponent = ({ block, pageId, selectedLanguage, handleAttributeAdded }: { 
    block: any; 
    pageId: string; 
    handleAttributeAdded: (updatedBlockId: string, newAttribute: Attribute) => void;
    selectedLanguage: string 
}) => {
    const intl = useIntl()
    const {refetchData} = useQueryResponse()
    const confirm = useConfirm()

    const [images, setImages] = useState<Image[]>([]);
    const [selectedImage, setSelectedImage] = useState<Image | null>(null);
    const [selectedSlider, setSelectedSlider] = useState<SliderItem | null>(null);
    const [items, setItems] = useState<SliderItem[]>(block?.slider?.items || []);
    const [title, setTitle] = useState(block?.slider?.name || '');
    const [time, setTime] = useState(block?.slider?.time || '');
    const [sliderId, setSliderId] = useState(block?.slider?._id || '');

    const [isActive, setIsActive] = useState(block?.slider?.isActive || false);

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalAddImageOpen, setIsModalAddImageOpen] = useState(false)
    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setTitle(e.target.value);
    };
    const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setTime(e.target.value);
    };

    const handleImageClick = (item: SliderItem) => {
        console.log("Image cliquée:", item.image); // Vérification
        if (!item.image._id) {
            console.error("L'image cliquée n'a pas d'_id", item.image);
            return;
        }
        setSelectedSlider(item)
        setSelectedImage(item.image);
        setIsModalOpen(true);
    };
    const handleImageAdd = () => {
        setIsModalAddImageOpen(true);
    };
    const handleCloseModalAddImage = () => {
        setIsModalAddImageOpen(false)
    }

    // const handleImageClick = (img: images) => {
    //     setSelectedImage(img)
    //     setIsModalOpen(true)
    // }
    
    const handleCloseModal = () => {
        setIsModalOpen(false)
        setSelectedImage(null)
    }
    const handleImageAdded = (newImage: {url: string; _id: string}) => {
        setImages((prevImages) => [
        ...prevImages,
        {
        ...newImage,
        seoUrl: '',
        _id: newImage._id as unknown as ID,
        },
        ])
        }

        const handleAddImage = async (newImage: any) => {
            try {
                  console.log('newImage',newImage)
                  const response = await createOne(newImage,`/sliders/${sliderId}/item?placement=slider`);
                  refetchData()

                  if (response?.payload?.code === 4205) {
                    toast.success(
                      intl.formatMessage({
                        id: 'ADMIN.COMMON.SUCCESS.ITEM_ADDED_SUCCESSFULLY', 
                      }),
                      {
                        position: 'top-right',
                        autoClose: 4000,
                      }
                    );
                    setItems((prevItems) => [
                      ...prevItems,
                      response?.data,
                    ]);
                  
                  } else if (response?.payload?.code === 4400) {
                    toast.error(
                      intl.formatMessage({
                        id: 'ADMIN.COMMON.ERROR.NAME_ALREADY_EXIST',
                      }),
                      {
                        position: 'top-right',
                        autoClose: 4000,
                      }
                    );
                  } else {
                    toast.error(
                      intl.formatMessage({
                        id: 'ADMIN.COMMON.ERROR.ERROR_ADDING_ITEM', // Add this translation to your JSON files
                      }),
                      {
                        position: 'top-right',
                        autoClose: 4000,
                      }
                    );
                  }
            
            } catch (error) {
                console.error('Error adding image:', error);
                toast.error(
                  intl.formatMessage({
                    id: 'ADMIN.COMMON.ERROR.IMAGE_UPDATED',
                  }),
                  {
                    position: 'top-right',
                    autoClose: 4000,
                  }
                );
            }
        };
          
    const handleUpdateImage = async (updatedImage: any) => {
        if (!selectedImage || !selectedImage._id) {
            console.error("selectedImage ou son _id est undefined", selectedImage);
            return;
        }
    
    
        if (!selectedImage._id) {
            console.error("selectedImage._id est undefined");
            return;
        }
    
        console.log("selectedImage utilisé pour la requête:", selectedImage);
        console.log("updatedImage.imageId:", updatedImage.imageId);
        console.log("selectedImage._id:", selectedImage._id);
    
        const formData = new FormData();
        if (selectedImage._id) {
          formData.append('imageId', selectedImage._id.toString());
          if (updatedImage.seoUrl) {
            formData.append('seoUrl', updatedImage.seoUrl);
          }
          if (updatedImage.url !== selectedImage.url) {
            const response = await fetch(updatedImage.url);
            const blob = await response.blob();
            const file = new File([blob], 'updated-image.jpg', { type: blob.type });
            formData.append('image', file);
        }
        }

        formData.append('link', updatedImage.link ?? '');
        if (updatedImage.videoType) {
          formData.append('videoType', updatedImage.videoType);
        }
        formData.append('videoUrl', updatedImage.videoUrl || '');
        formData.append('videoAutoplay', String(!!updatedImage.videoAutoplay));
        formData.append('videoLazy', String(updatedImage.videoLazy !== false));
        const translation = Array.isArray(updatedImage.translations)
          ? updatedImage.translations.find(Boolean)
          : null;
        if (translation) {
          const translationId = translation._id ? String(translation._id) : '';
          if (/^[a-fA-F0-9]{24}$/.test(translationId)) {
            formData.append('translations[0][_id]', translationId);
          }
          formData.append('translations[0][text]', translation.text || '');
          formData.append('translations[0][language]', translation.language || '');
          formData.append('translations[0][description]', translation.description || '');
          formData.append('translations[0][buttonText]', translation.buttonText || '');
        }

        try {
            await patchOne(formData, `/sliders/item/${selectedSlider?._id}?placement=slider`).then((response) => {
                if (response?.payload?.code === 2021 || response?.data?._id) {
                  console.log("response?.data",response?.data)
                    queryClient.invalidateQueries([QUERIES.SECTION_LIST, block.pageId]);
                    setItems((prevItems) =>
                      prevItems.map((item) =>
                        item._id === response?.data?._id ? response?.data : item
                      )
                    );
                        
                //    const updatedAttributes = formik.values.attributes.map((attr: Attribute) =>
                  //      attr.image?.url === selectedImage.url
                   //         ? { ...attr, image: { ...attr.image, ...updatedImage } }
                   //         : attr
                    //);
    
                   // formik.setFieldValue('attributes', updatedAttributes);
                    handleCloseModal();
                    toast.success(intl.formatMessage({ id: 'ADMIN.COMMON.SUCCESS.BLOCKS_UPDATED_SUCCESSFULLY' }), {
                        position: 'top-right',
                        autoClose: 4000,
                    });
                } else {
                    toast.error(intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.BLOCKS_UPDATED' }), {
                        position: 'top-right',
                        autoClose: 4000,
                    });
                }
            });
        } catch (error) {
            toast.error(intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.BLOCKS_UPDATED' }), {
                position: 'top-right',
                autoClose: 4000,
            });
        }
    };
    const handleDelete = async () => {
      const ok = await confirm({})
      if (!ok) return
      try {
        const response = await deleteOne(sliderId, '/sliders');
        if (response?.payload?.code === 4202) {
          toast.success(
            intl.formatMessage({ id: 'ADMIN.COMMON.SUCCESS.SLIDER_DELETED_SUCCESSFULLY' }),
            { position: 'top-right', autoClose: 4000 }
          );
          setSliderId('')

          // Optionally, you can redirect or refresh the page after deletion
          // window.location.reload(); // Example: Refresh the page
        } else {
          toast.error(
            intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.SLIDER_DELETED' }),
            { position: 'top-right', autoClose: 4000 }
          );
        }
      } catch (error) {
        toast.error(
          intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.SLIDER_DELETED' }),
          { position: 'top-right', autoClose: 4000 }
        );
      }
    };
    
    const handleUpdateSlider = async () => {
      try {
          const payload = {
            name: title, 
            time: Number(time),  
            isActive: isActive,
          };
          console.log('payload',payload)
          await patchOne(payload, `/sliders/${sliderId}`).then((response) => {
              if (response?.payload?.code === 4201) {
                console.log("response?.data",response?.data)
                  queryClient.invalidateQueries([QUERIES.SECTION_LIST, block.pageId]);
                  toast.success(intl.formatMessage({ id: 'ADMIN.COMMON.SUCCESS.SLIDER_UPDATED_SUCCESSFULLY' }), {
                      position: 'top-right',
                      autoClose: 4000,
                  });
                  setIsActive(response?.data?.isActive)
                  setTitle(response?.data?.name)
                  setTime(response?.data?.time)

              } else {
                  toast.error(intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.SLIDER_UPDATED' }), {
                      position: 'top-right',
                      autoClose: 4000,
                  });
              }
          });
      } catch (error) {
          toast.error(intl.formatMessage({ id: 'ADMIN.COMMON.ERROR.SLIDER_UPDATED' }), {
              position: 'top-right',
              autoClose: 4000,
          });
      }
  };  
    const queryClient = useQueryClient()       

      const handleDeleteImage = async (item: SliderItem) => {
        const ok = await confirm({})
        if (!ok) return
        try {
          await deleteOne(item._id as unknown as ID, '/sliders/item').then((response: DeleteResponse) => {
            if (response?.payload?.code === 4207) {
              setItems((prevItems) => prevItems.filter((i) => i._id !== item._id));
              refetchData()

              toast.success(
                intl.formatMessage({
                  id: 'ADMIN.COMMON.SUCCESS.ITEM_UPDATED_SUCCESSFULLY',
                }),
                {
                  position: 'top-right',
                  autoClose: 4000,
                }
              )
            } else {
              toast.error(
                intl.formatMessage({
                  id: 'ADMIN.COMMON.ERROR.ITEM_UPDATED',
                }),
                {
                  position: 'top-right',
                  autoClose: 4000,
                }
              )
            }
          })
        } catch (error) {
          toast.error(
            intl.formatMessage({
              id: 'ADMIN.COMMON.ERROR.ITEM_UPDATED',
            }),
            {
              position: 'top-right',
              autoClose: 4000,
            }
          )
        }
      }      
    const handleToggleChange = async (id: string,newIsActive: boolean) => {
        try {
            const payload={
                'isActive':newIsActive
            }
           const response= await patchOne(payload, `/sliders/${sliderId}`);
           if (response?.payload?.code === 4201) {
            toast.success(
                intl.formatMessage({
                    id: 'ADMIN.COMMON.SUCCESS.STATUS_UPDATED_SUCCESSFULLY',
                }),
                {
                    position: 'top-right',
                    autoClose: 4000,
                }
            )
            //formik.setFieldValue('isActive', newIsActive);


        }
        } catch (error) {
            toast.error(
                intl.formatMessage({
                    id: 'ADMIN.COMMON.ERROR.STATUS_UPDATED',
                }),
                {
                    position: 'top-right',
                    autoClose: 4000,
                }
            )
            //formik.setFieldValue('isActive', !newIsActive);
        }
    };
    
    return (
        <>
            {sliderId && ( 

        <KTCardBody className='py-4'>
            <h2 className='my-2'>{title}</h2>
                <div className='my-3'>
                    <ToggleButton 
                        id={block._id}
                        isActive={isActive} 
                        onChange={handleToggleChange} 
                    />
                </div>
                <label className="form-label">{intl.formatMessage({ id: 'BLOCK.NAME' })}</label>
                <input
                    type="text"
                    className="form-control mb-4"
                    value={title}
                    onChange={handleTitleChange}
                    placeholder={intl.formatMessage({ id: 'BLOCK.NAME' })}
                />
                <label className="form-label">{intl.formatMessage({ id: 'BLOCK.TIMER' })}</label>
                <input
                    type="number"
                    className="form-control mb-4"
                    value={time}
                    onChange={handleTimeChange}
                    placeholder={intl.formatMessage({ id: 'BLOCK.TIMER' })}
                />

            <section className='gallery-section py-4'>
              <div className='gallery gallery-style'>
              <ImageGallery
                items={items}
                handleImageClick={handleImageClick}
                handleDeleteImage={handleDeleteImage}
                handleImageAdded={handleImageAdd}
                handleImageUploaded={handleImageAdded}
                hotelId={'hotels?._id'}
                />
              </div>
              <div className='modal-footer'>
                           <button
                                type="submit"
                                className='btn btn-light me-2'
                                data-kt-sections-modal-action='cancel'
                                onClick={handleDelete} 
                            >
                                {intl.formatMessage({
                                    id: 'HEADER.DELETE',
                                })}
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary me-2"
                                onClick={handleUpdateSlider} 
                                >
                                {intl.formatMessage({
                                    id: 'HEADER.SAVE',
                                })}
                            </button>

                        </div>
                        <div className='separator mt-4'></div>

            </section>
            <ImageEditModal
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              selectedImage={selectedImage || {url: '', seoUrl: ''}}
              selectedSlider={selectedSlider || { _id: '', slider_id: '', image: { _id: '', url: '' }, link: '', translations: [] }}
              selectedSliderItemId={selectedSlider?._id || ''}
              onSave={handleUpdateImage}
            />
            <ImageAddModal
              isOpen={isModalAddImageOpen}
              onClose={handleCloseModalAddImage}
              onSave={handleAddImage}
            />

        </KTCardBody>
    )}

        </>


    )
}

export { SliderComponent };